var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.82726 5.18301C7.64182 3.61067 9.96324 2.74666 12.3643 2.75001C17.8873 2.75001 22.3643 7.22701 22.3643 12.75C22.3643 14.886 21.6943 16.866 20.5543 18.49L17.3643 12.75H20.3643C20.3644 11.1816 19.9035 9.64781 19.0389 8.33927C18.1743 7.03072 16.9442 6.00517 15.5014 5.39013C14.0587 4.7751 12.467 4.59771 10.9242 4.88003C9.38146 5.16234 7.95571 5.89191 6.82426 6.97801L5.82726 5.18301ZM18.9013 20.317C17.0867 21.8893 14.7653 22.7534 12.3643 22.75C6.84126 22.75 2.36426 18.273 2.36426 12.75C2.36426 10.614 3.03426 8.63401 4.17426 7.01001L7.36426 12.75H4.36426C4.36413 14.3184 4.82501 15.8522 5.68959 17.1608C6.55418 18.4693 7.78433 19.4949 9.22708 20.1099C10.6698 20.7249 12.2615 20.9023 13.8043 20.62C15.3471 20.3377 16.7728 19.6081 17.9043 18.522L18.9013 20.317Z",
    fill: "#093549"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.915dc02acfb03d797097fa7ec51b9d52.svg";
export { ForwardRef as ReactComponent };